import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import { GooglePlacesAutocomplete } from 'react-native-google-places-autocomplete';

import Theme from '../../theme';
import Sizes from '../../sizes';
import { Icon } from '../../components';
import { getApiConfig } from '../../config';
import { defaultScale } from '../../utils/scaling';

const extractedFields = [
    'street_number',
    'route',
    'locality',
    'sublocality_level_1',
    'administrative_area_level_1',
    'administrative_area_level_2',
    'country',
    'postal_code',
]

class GoogleAddressSearch extends PureComponent {
    state = {
        listViewDisplayed: 'auto',
        countries: 'country:au',
    }

    extractFields = (data, details) => {
        const { onAddressPress } = this.props;
        const { address_components } = details;
        const mappedFields = address_components.reduce((resultMapped, address) => {
            let typePair;
            address.types.forEach(type => {
                if (extractedFields.indexOf(type) > -1) {
                    typePair = type;
                }
            });

            return {
                ...resultMapped,
                [typePair]: address.long_name,
            };
        }, {});

        mappedFields.addressLine1 = data.structured_formatting.main_text;
        let addressLine2 = mappedFields.locality;
        if (mappedFields.sublocality_level_1) {
            addressLine2 = `${mappedFields.sublocality_level_1}, ${addressLine2}`;
        }
        mappedFields.addressLine2 = addressLine2;

        onAddressPress(mappedFields);
    }

    render() {
        const { listViewDisplayed, countries } = this.state;
        const { API_BASE_URL } = getApiConfig();
        return (
            <View className="addressSearchContainer">
                <GooglePlacesAutocomplete
                    suppressDefaultStyles
                    placeholder='Search for location'
                    minLength={2}
                    autoFocus={false}
                    returnKeyType={'default'}
                    fetchDetails={true}
                    listViewDisplayed={listViewDisplayed}
                    query={{
                        language: 'en',
                        types: 'address',
                        components: countries,
                        key: 'GOOGLE_API_FAKE_KEY',
                    }}
                    requestUrl={{
                        useOnPlatform: 'all',
                        url: `${API_BASE_URL}/api/google-maps`,
                    }}
                    onPress={(data, details = null) => {
                        this.setState({ listViewDisplayed: false });
                        this.extractFields(data, details);
                    }}
                    styles={{
                        textInputContainer: styles.textInputContainer,
                        textInput: styles.textInput,
                        row: styles.row,
                        poweredContainer: styles.poweredContainer,
                        loader: styles.loader,
                        container: styles.googleContainer,
                        separator: styles.separator,
                    }}
                    renderRightButton={() => (
                        <View style={styles.rightButtonContainer}>
                            <Icon
                                size={defaultScale(30)}
                                name={'ios-navigate-outline'}
                                color={Theme.GREY_DARK}
                            />
                        </View>
                    )}
                />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    googleContainer: {
        marginVertical: defaultScale(5),
    },
    textInputContainer: {
        borderRadius: 3,
        flexDirection: 'row',
        height: defaultScale(Sizes.InputHeight),
        backgroundColor: Theme.GREY_LIGHT,
    },
    textInput: {
        flex: 1,
        ...Theme.textStyle.bodyCopyReg,
        paddingRight: defaultScale(15),
        paddingHorizontal: defaultScale(15),
        color: Theme.GREY_DARK,
        backgroundColor: Theme.GREY_LIGHT,
    },
    row: {
        width: '95%',
        paddingVertical: defaultScale(10),
        paddingHorizontal: defaultScale(15),
        flexDirection: 'row',
    },
    poweredContainer: {
        display: 'none',
    },
    loader: {
        paddingLeft: defaultScale(5),
    },
    separator: {
        backgroundColor: Theme.GREY,
        height: StyleSheet.hairlineWidth,
    },
    rightButtonContainer: {
        paddingRight: defaultScale(5),
        justifyContent: 'center'
    }
});

export default GoogleAddressSearch;
